import { getOptionsProvider } from '@shared/OptionsProvider';
import type { TicketingOptions } from '@shared-types/ticketing.types';

export const { OptionsProvider: TicketingOptionsProvider, useOptions: useTicketingOptions } =
  getOptionsProvider<TicketingOptions>();
